module.exports = __webpack_public_path__ + "static/media/image-prime.63563cb1.jpg";